<template>
  <b-container>
    <h1 v-translate>Edit Quote</h1>
    <b-alert
      :show="dismissCountDown"
      dismissible
      variant="success"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
    >
      <translate>The Quote has been updated</translate>
    </b-alert>
    <quotes-create
      v-if="done === true"
      :quote-data="quoteData"
      :base-area-from="areaFrom"
      :base-area-to="areaTo"
      :base-company="company"
      @quoteupdated="showAlert"
    />
  </b-container>
</template>

<script>
import QuotesCreate from '@/components/QuotesCreate'
export default {
  components: {
    QuotesCreate
  },
  data() {
    return {
      quotes: {},
      quoteFormulas: {},
      quoteFormulaValues: {},
      quoteData: {},
      company: null,
      areaFrom: null,
      areaTo: null,
      done: false,
      dismissSecs: 5,
      dismissCountDown: 0
    }
  },
  mounted() {
    this.fetchQuote()
  },
  methods: {
    fetchQuote() {
      let params = {
        includes: [
          'quote_companies.company'
        ]
      }
      this.$http.get(this.$appConfig.api.baseUrl + 'quotes/' + this.$route.params.id, {params: params})
        .then(response => {
          this.quoteData.quotes = response.data
          this.quoteData.quoteCompanies = response.data.quote_companies.map(x => { return {id: x.company.id, name: x.company.name} })
          if (response.data.area_id_from !== null) {
            this.$http.get(this.$appConfig.api.baseUrl + 'areas/' + response.data.area_id_from)
              .then(response => {
                this.areaFrom = response.data
              })
          }
          if (response.data.area_id_to !== null) {
            this.$http.get(this.$appConfig.api.baseUrl + 'areas/' + response.data.area_id_to)
              .then(response => {
                this.areaTo = response.data
              })
          }
          if (response.data.company_id !== null) {
            this.$http.get(this.$appConfig.api.baseUrl + 'companies/' + response.data.company_id)
              .then(response => {
                this.company = response.data
              })
          }
          console.log(this.quoteData)
          this.$http.get(this.$appConfig.api.baseUrl + 'quote-formulas/' + this.quoteData.quotes.quote_formula_id)
            .then(response => {
              this.quoteData.quoteFormulas = response.data

              this.$http.get(this.$appConfig.api.baseUrl + 'quote-formula-values/' + this.quoteData.quoteFormulas.quote_formula_value_id)
                .then(response => {
                  this.quoteData.quoteFormulaValues = response.data
                  if (this.quoteData.quoteFormulaValues.values === null || this.quoteData.quoteFormulaValues.values.length === 0) {
                    this.quoteData.quoteFormulaValues.values = {}
                  }
                  this.done = true
                })
            })
        })
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    }
  }
}
</script>
